export const households = [
  {
    label: "Adults",
    value: 1820,
  },
  {
    label: "51-59",
    value: 400,
  },
  {
    label: "60-64",
    value: 177,
  },
  {
    label: "65+",
    value: 236,
  },
  {
    label: "Children",
    value: 1808,
  },
  {
    label: "Total",
    value: 4441,
  },
]
